import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { Badge, IconButton, Popover, Tooltip } from "@mui/material";

import BellIcon from "../IconComponents/BellIcon";
import NotificationItemStack from "./NotificationItemStack";
import { getNewNotificationsNumber } from "../../ReduxTLK/features/Notifications/NotificationSlice";
import { NavContext } from "../../App";

import styles from "./NotificationList.module.css";

export default function NotificationList() {
  const dispatch = useDispatch();
  const context = useContext(NavContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(getNewNotificationsNumber())
      .then(unwrapResult)
      .then((res) => context.setNewNotification(res?.data?.data?.result))
      .catch((error) =>
        console.error("Error fetching notifications count:", error)
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.newNotification]);

  return (
    <>
      <Tooltip title="Notifications" arrow>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          className={styles.triggerBtn}
          aria-label={`Notifications${
            context.newNotification ? ` (${context.newNotification} nouvelles)` : ""
          }`}
        >
          <Badge
            badgeContent={context.newNotification}
            color="error"
            overlap="circular"
            max={99}
          >
            <BellIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: styles.popoverPaper } }}
      >
        <div className={styles.popoverHeader}>
          <span className={styles.popoverTitle}>Notifications</span>
          {context.newNotification > 0 && (
            <span className={styles.unreadPill}>
              {context.newNotification} nouvelle
              {context.newNotification > 1 ? "s" : ""}
            </span>
          )}
        </div>

        {/* Monté uniquement quand ouvert : le fetch ne part qu'à l'ouverture */}
        {open && <NotificationItemStack onClose={() => setAnchorEl(null)} />}
      </Popover>
    </>
  );
}